"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lib_1 = require("../../lib");
var getSizes_1 = __importDefault(require("../../lib/getSizes"));
var prepareUploadcareUrl_1 = __importDefault(require("../../lib/prepareUploadcareUrl"));
var getGifPoster = function (options) {
    var imageDetails = options.imageDetails, filename = options.filename, src = options.src, _a = options.effects, effects = _a === void 0 ? [] : _a, width = options.width;
    var sizes = getSizes_1.default(options);
    return prepareUploadcareUrl_1.default({
        width: width || sizes.default,
        imageDetails: imageDetails,
        src: src,
        filename: filename,
        effects: __spreadArray(__spreadArray([], __read(effects)), [lib_1.effect.format('png'), lib_1.effect.format('auto')]),
    });
};
exports.default = getGifPoster;
//# sourceMappingURL=getGifPoster.js.map